<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'fixed-price-invoice',
};
</script>

<style>
</style>
